import ApiService from "service/Api";
import { MediaPayloadTypes } from "utilities/types/Media";

const MediaService = {
  getAllMedias: async () => {
    const requestData = {
      method: "get",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/media",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  storeMedia: async (payload: MediaPayloadTypes) => {
    const { name, link, image, wording, status } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        name: name,
        link: link,
        image: image,
        wording: wording,
        status: status,
      },
      url: "/admin/media",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  updateMedia: async (mediaId: string, payload: MediaPayloadTypes) => {
    const { name, link, image, wording, status } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        name: name,
        link: link,
        image: image,
        wording: wording,
        status: status,
        _method: "PUT",
      },
      url: "/admin/media/" + mediaId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },

  deleteMedia: async (mediaId: string) => {
    const requestData = {
      method: "delete",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      url: "/admin/media/" + mediaId,
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default MediaService;
